 /* jshint esversion: 6 */
// import * as Cookies from 'js-cookie'

export default {
  SET_MESSAGE: (state, { show = false, content = {} }) => {
    state.msg.show = show;
    state.msg.content = content;
  },
  SET_MSG_HEADER: (state, { count = 0, list = [] }) => {
    state.msg.count = count;
    state.msg.list = list;
  },
  SET_SOCKET_CONNECT_NO: (state, { number = 0 }) => {
    state.msg.number = number;
  },
};
